import { useEffect, useRef } from "react";
import api from "@/api/api.js";
import $ from "jquery";
import "datatables.net";
import languageES from "datatables.net-plugins/i18n/es-MX";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";
import { formatDate } from "@/utils/formatDate";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

const CompaniesContacts = () => {
  const { t } = useTranslation();
  const tableRef = useRef(null);
  const dataTable = useRef(null);
  const userId = sessionStorage.getItem("user");
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId) return;
    const currentTable = tableRef.current;

    if ($.fn.DataTable.isDataTable(currentTable)) {
      $(currentTable).DataTable().clear().destroy();
      $(currentTable).empty();
    }

    dataTable.current = $(currentTable).DataTable({
      language: {
        ...languageES,
        emptyTable: t("ui.emptyClients"),
        zeroRecords: t("ui.emptyClients"),
      },
      processing: true,
      serverSide: true,
      ajax: (dtParams, callback) => {
        const search = dtParams.search?.value || "";
        api
          .get(`/contacts/${userId}/all`, {
            params: search ? { search } : {},
          })
          .then(({ data }) => {
            callback({
              draw: dtParams.draw,
              recordsTotal: data["hydra:totalItems"],
              recordsFiltered: data["hydra:totalItems"],
              data: data["hydra:member"],
            });
          })
          .catch(() => {
            callback({
              draw: dtParams.draw,
              recordsTotal: 0,
              recordsFiltered: 0,
              data: [],
            });
          });
      },
      columns: [
        { title: capitalizeFirstLetter(t("name")), data: "businessName" },
        {
          title: capitalizeFirstLetter(t("taxIdentification")),
          data: "taxIdentification",
        },
        { title: capitalizeFirstLetter(t("company type")), data: "type" },
        { title: capitalizeFirstLetter(t("email")), data: "emailContact" },
        {
          title: capitalizeFirstLetter(t("certificate valid until")),
          render: (data, type, row) => {
            if (row["certificateTaxValidDate"] === undefined) {
              return "No tiene certificado";
            }

            return formatDate(row["certificateTaxValidDate"], false);
          },
        },
        { title: capitalizeFirstLetter(t("postal code")), data: "postalCode" },
        {
          title: "Acciones",
          render: function (data, type, row) {
            const contactId = row["@id"].split("/").pop();

            return `
                            <button class="w-100 mb-2 btn btn-primary btn-edit-contact" data-id="${contactId}">Editar</button>
                            <button class="w-100 mb-2 btn btn-warning btn-detail-contact"  data-id="${contactId}">Detalle</button>
                            <button class="w-100 btn btn-danger btn-delete-contact"  data-id="${contactId}">Borrar</button>
                        `;
          },
        },
      ],
    });

    const handleEditClick = function () {
      const contactId = $(this).data("id");
      navigate(`/contacts/${contactId}/edit`);
    };
    const handleShowClick = function () {
      const contactId = $(this).data("id");
      navigate(`/contacts/${contactId}/show`);
    };
    const handleDeleteClick = function () {
      const contactId = $(this).data("id");
      Swal.fire({
        title: "¿Quitar este cliente?",
        text: t("ui.clientDeleteWarning"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          api
            .delete(`/contacts/${contactId}`)
            .then(() => {
              dataTable.current.ajax.reload();
              Swal.fire(t("ui.clientDeletedTitle"), t("ui.clientDeleted"), "success");
            })
            .catch(() => {
              Swal.fire("Error", t("ui.clientDeleteError"), "error");
            });
        }
      });
    };
    $(currentTable).on("click", ".btn-edit-contact", handleEditClick);
    $(currentTable).on("click", ".btn-detail-contact", handleShowClick);
    $(currentTable).on("click", ".btn-delete-contact", handleDeleteClick);

    return () => {
      if ($.fn.DataTable.isDataTable(currentTable)) {
        $(currentTable).DataTable().clear().destroy();
      }
      $(currentTable).off("click", ".btn-edit-contact", handleEditClick);
      $(currentTable).off("click", ".btn-detail-contact", handleShowClick);
      $(currentTable).off("click", ".btn-delete-contact", handleDeleteClick);
    };
  }, [userId, navigate, t]);

  return (
    <>
      <div className="col">
        <div className="card">
          <div className="card-body">
            <div className="card-title">
              <h5 className="card-title pb-3">{t("page.clients")}</h5>
            </div>
            <div className={"card-body"}>
              <table
                ref={tableRef}
                className="display"
                style={{ width: "100%" }}
              ></table>
            </div>
            <div>
              <Link to={`/contacts/create`} style={{ textDecoration: "none" }}>
                <Button variant="primary" className="mb-3">
                  {t("ui.newClient")}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompaniesContacts;
